
	export default {
		props: {
			item: { default: null },
			moderators: { default: [] },
			isShowAvatar: { default: false },
		},
		methods: {
			getAvatarClass(id){
				return this.moderators.includes(id)? 'bg-theme text-white' : 'bg-white/50 text-black';
			},
			getNameTextColorClass(id){
				return this.moderators.includes(id)? 'text-black' : 'text-theme';
			},
			getMessageTextColorClass(id){
				return this.moderators.includes(id)? 'text-theme' : 'text-black';
			},
			getMessageName(item){
				return item.user?.name;
				// return this.moderators.includes(item.id)? 'Admin' : item.user?.name;
			},
			convertTextToUrl(text) {
			    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
			    return text.replace(urlRegex, function(url, b, c){
			        const url2 = (c == 'www.') ?  `http://${ url }` : url;
			        return `<a href="${ url2 }" target="_blank" class="text-black"><u class="break-all">${ url }</u></a>`;
			    });
			},
		}
	}
